import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

// Unified topic list: usertype, language, assessType, class (SV or 1-10), subject
export const getMasterStudActTopicsThunk = createAsyncThunk(
  "topics/get",
  async (data) => {
    let response = await api.get(
      `getMasterStudActTopics/${data.usertype}/${data.language}/${data.assessType}/${data.quizClass}/${data.subject}`
    );
    return response.data;
  }
);

//FLN get api

export const getTeacherBaselineFlnThunk = createAsyncThunk(
  "fln/get",
  async (data) => {
    let response = await api.get(
      `getMasterStudActTopics/${data.usertype}/${data.language}/${data.assessType}/${data.quizClass}/${data.subject}/${data.program}`
    );
    return response.data;
  }
);

//ECE get api
export const getTeacherBaselineEceThunk = createAsyncThunk(
  "ece/get",
  async (data) => {
    console.log(data, "jhbfdfdbf");
    let response = await api.get(
      `getMasterStudActTopics/${data.usertype}/${data.language}/${data.assessType}/${data.quizClass}/${data.program}`
    );
    return response.data;
  }
);

//PGE get api
export const getTeacherBaselinePgeThunk = createAsyncThunk(
  "pge/get",
  async (data) => {
    let response = await api.get(
      `getMasterStudActTopics/${data.usertype}/${data.language}/${data.quizClass}/${data.subject}`
    );
    return response.data;
  }
);

//Community get api
export const getTeacherBaselineCommunityThunk = createAsyncThunk(
  "community/get",
  async (data) => {
    let response = await api.get(
      `getMasterStudActTopics/${data.usertype}/${data.language}/${data.assessType}`
    );
    return response.data;
  }
);

export const createTeacherBaselineThunk = createAsyncThunk(
  "teacherexam/create",
  async (body) => {
    let response = await api.post("saveMasterStudActSkill", body);
    return response.data;
  }
);

export const updateTeacherBaselineThunk = createAsyncThunk(
  "teacherexam/update",
  async (reqbody) => {
    const id = reqbody.skillId;
    const { _id, ...body } = reqbody; // remove _id from reqbody and create new object called body

    let response = await api.put("updateMasterStudActSkill/" + id, body);
    return response.data;
  }
);

export const deleteTeacherBaselineThunk = createAsyncThunk(
  "teacherexam/delete",
  async (topicId) => {
    let response = await api.delete("deleteMasterStudActTopic/" + topicId);
    return response.data;
  }
);
